module.exports = {
  sequelize: require('./sequelize')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/yayson/lib/yayson/adapters/index.js
// module id = 1mLc
// module chunks = 3